import React, { useState, useRef } from 'react';
import SearchIcon from '../../components/svg/Search';
import styled, { css } from 'styled-components/macro';
import matchSorter from 'match-sorter';


const FiltroCandidatos = ({candidatos, setCandidatos}) => {
  const setFilter = (text) =>{
    setCandidatos(matchSorter(candidatos, text, { keys: ['codcan','nomcan','apecan']}))
  }
  return(
    <div css={`display:flex;`}>
      <Input placeholder={'filtrado de candidato...'}
        onChange={e => {
          setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
        }}
      />
      <SearchIconWrapper>
        <SearchIcon fill={'#283F5F'}/>
      </SearchIconWrapper>
    </div>
  );
}

export default FiltroCandidatos;

const SearchIconWrapper = styled.div`
  background-color: transparent;
  border: none;
  right: 10px;
  top: 0;
  width: 47px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 2rem;
  /*IE11: Column flex items set to align-items: center overflow their container https://github.com/philipwalton/flexbugs#flexbug-2 */
  max-width: 47px;
`;


const Input = styled.input`
  position: relative;
  box-sizing: border-box;
  border: none;
  font-size: 14px;
  background-color: transparent;
  // transition: background-color 0.3s ease 0s;
  border-bottom: 1px solid #bbb;
  ::placeholder {
    font-style: italic;
    opacity: 0.9;
  }
`;